import { Flex } from '@chakra-ui/react'
import { useColorMode } from 'uikit/ColorMode/ColorMode'

export const FilterFooter = ({ children, ...props }) => {
  const { colorMode } = useColorMode()
  
  return (
    <Flex
      width="100%"
      flexDirection="column"
      zIndex={2}
      pt="30px"
      pb="10px"
      alignItems="center"
      justifyContent="center"
      position="sticky"
      bottom="0"
      borderTopWidth={1}
      bgColor="gray100"
      pl="26px"
      pr="26px"
      {...props}
    >
      {children}
    </Flex>
  )
}
